import { PLAN_CODES } from '../../../modals/upgrade-plan/constants';
const getPlanFeatures = (self, planCode) => {
    var _a, _b;
    if (!self.pricingPlanFeatures) {
        return [];
    }
    const groups = self.pricingPlanFeatures.plan_groups;
    let currentGroup = null;
    groups.forEach(group => {
        if (parseFloat(self.pricingVersion) >= parseFloat(group.version_min) &&
            parseFloat(self.pricingVersion) <= parseFloat(group.version_max)) {
            currentGroup = group;
        }
    });
    if (!currentGroup) {
        return [];
    }
    const planFeatureDetail = (_a = currentGroup.plans) === null || _a === void 0 ? void 0 : _a.find(({ plan_name }) => plan_name === planCode);
    return (_b = planFeatureDetail === null || planFeatureDetail === void 0 ? void 0 : planFeatureDetail.features) !== null && _b !== void 0 ? _b : [];
};
const Views = self => ({
    get proPlan() {
        return self.plans.find(plan => plan.code === PLAN_CODES.PRO);
    },
    get proMonthlyPrices() {
        const plan = self.proPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.filter(price => price.interval.unit === 'month' && price.active);
    },
    get proAnnualPrices() {
        const plan = self.proPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.filter(price => price.interval.unit === 'year' && price.active);
    },
    get proSeatProducts() {
        return self.seatProducts.find(sp => sp.planCode === PLAN_CODES.PRO);
    },
    get proFeatures() {
        return getPlanFeatures(self, PLAN_CODES.PRO);
    },
    get starterPlan() {
        return self.plans.find(plan => plan.code === PLAN_CODES.STARTER);
    },
    get starterMonthlyPrice() {
        const plan = self.starterPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.find(price => price.interval.unit === 'month' && price.active);
    },
    get starterAnnualPrice() {
        const plan = self.starterPlan;
        if (!plan) {
            return [];
        }
        return plan.prices.find(price => price.interval.unit === 'year' && price.active);
    },
    get starterFeatures() {
        return getPlanFeatures(self, PLAN_CODES.STARTER);
    },
});
export default Views;
